import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#5e0301', // #E53935
                secondary: '#5e0301', // #FFCDD2
                accent: '#B0916B', // #3F51B5
            },
        },
        dark: false
    },
})
